import { Outlet, NavLink } from "react-router"
import { useAuth } from "@/lib/auth"

const PLATFORM_NAV_ITEMS = [
  { to: "/platform", label: "Overview", icon: OverviewIcon, end: true },
  { to: "/platform/users", label: "Users", icon: UsersIcon },
  { to: "/platform/properties", label: "Properties", icon: PropertiesIcon },
]

export function PlatformShell() {
  const { user, logout } = useAuth()

  const initials = user?.name
    ? user.name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase()
    : user?.email?.slice(0, 2).toUpperCase() || "?"

  return (
    <div className="shell">
      <nav className="rail" aria-label="Platform navigation">
        <div className="rail__brand">
          <div className="rail__brand-mark">S</div>
          Platform
        </div>

        <div className="rail__nav" role="list">
          {PLATFORM_NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              role="listitem"
              className={({ isActive }) =>
                `rail__nav-item${isActive ? " rail__nav-item--active" : ""}`
              }
            >
              <item.icon />
              {item.label}
            </NavLink>
          ))}

          <div style={{
            borderTop: "1px solid var(--sf-border)",
            margin: "var(--sf-space-3) var(--sf-space-4)"
          }} />
          <NavLink to="/" className="rail__nav-item">
            <BackIcon />
            Dashboard
          </NavLink>
        </div>

        <div className="rail__footer">
          <div className="rail__user">
            <div className="rail__user-avatar">{initials}</div>
            <span>{user?.name || user?.email || ""}</span>
          </div>
          <button className="rail__signout" onClick={logout} type="button">
            Sign out
          </button>
        </div>
      </nav>

      <main className="main">
        <Outlet />
      </main>
    </div>
  )
}

function OverviewIcon() {
  return (
    <svg className="rail__nav-icon" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="5.5" height="5.5" rx="1" />
      <rect x="10.5" y="2" width="5.5" height="5.5" rx="1" />
      <rect x="2" y="10.5" width="5.5" height="5.5" rx="1" />
      <rect x="10.5" y="10.5" width="5.5" height="5.5" rx="1" />
    </svg>
  )
}

function UsersIcon() {
  return (
    <svg className="rail__nav-icon" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="6" r="3" />
      <path d="M3 16c0-3 2.7-5.5 6-5.5s6 2.5 6 5.5" />
    </svg>
  )
}

function PropertiesIcon() {
  return (
    <svg className="rail__nav-icon" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 16V7l6-5 6 5v9H3Z" />
      <rect x="7" y="10" width="4" height="6" />
    </svg>
  )
}

function BackIcon() {
  return (
    <svg className="rail__nav-icon" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4L6 9l5 5" />
    </svg>
  )
}
